import { useEffect, useState } from 'react';
import Title from '../../../componente/cadastro/titulo/index.jsx';
import Description from '../../../componente/cadastro/descricao/index.jsx';
import SearchField from '../../../componente/cadastro/busca/index.jsx';
import AddButton from '../../../componente/cadastro/botaoadd/index.jsx';
import Table from '../../../componente/cadastro/tabela/index.jsx';
import TableTamanho from '../../../componente/cadastro/tabela/index.jsx';
import TableTecido from '../../../componente/cadastro/tabela/index.jsx';
import TableCor from '../../../componente/cadastro/tabela/index.jsx';
import Pagination from '../../../componente/cadastro/paginacao/index.jsx';
import Sidebar from "../../../componente/sidebar/index.jsx";
import "./style.css";
import api from "../../../services/api.js";
import { useAppContext } from "../../context/AppContext.jsx";
import { toast } from 'react-hot-toast';
import Modal from "react-modal";
import ModalTamanho from "react-modal";
import ModalTecido from "react-modal";
import ModalTecidoReplicar from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import PopUpTamanho from "../../../componente/popup/index.jsx";
import PopUpTecido from "../../../componente/popup/index.jsx";
import PopUpCor from "../../../componente/popup/index.jsx";
import Aguarte from "../../../componente/aguarde/index.jsx";
import { usePermissoes } from "../../../componente/permissoes";

Modal.setAppElement("#root");

const CadProduto = () => {
    const { podeInserir, podeEditar, podeExcluir } = usePermissoes();

    const [search, setSearch] = useState('');
    const [filtroTipo, setFiltroTipo] = useState('T');
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(50);
    const [data, setData] = useState([]);
    const [dataTamanho, setDataTamanho] = useState([]);
    const [dataTecido, setDataTecido] = useState([]);
    const [dataCor, setDataCor] = useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        totalPages: 0
    });
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [error, setError] = useState(null);
    const [showform, setshowform] = useState(false);
    const [showformtamanho, setshowformtamanho] = useState(false);
    const [showformtecido, setshowformtecido] = useState(false);
    const { accessKey, codassinante, codusuario } = useAppContext(); // Acessa os dados do contexto          
    const [novo, setnovo] = useState(false);
    const [novotamanho, setnovotamanho] = useState(false);
    const [novotecido, setnovotecido] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenTamanho, setIsOpenTamanho] = useState(false);
    const [isOpenTecido, setIsOpenTecido] = useState(false);
    const [isOpenCor, setIsOpenCor] = useState(false);
    const [isOpenTecidoReplicar, setIsOpenTecidoReplicar] = useState(false);
    const [abaAtiva, setAbaAtiva] = useState("dados");

    const columns = [
        { key: 'codproduto', title: 'Código' },
        { key: 'descricao', title: 'Modelo' },
        { key: 'unidade', title: 'UND' },
        { key: 'qtde', title: 'Estoque' },
        { key: 'valorbase', title: 'Preço', type: 'float' },
    ];
    const columnsTamanho = [
        { key: 'tamanho', title: 'Tamanho' },
    ];
    const columnsTecido = [
        { key: 'tecido', title: 'Tecido' },
    ];
    const columnsCor = [
        { key: 'cor', title: 'Cor' },
    ];

    //campos
    const [codproduto, setCodProduto] = useState(0);
    const [descricao, setDescricao] = useState("");
    const [valorbase, setValorBase] = useState(0);
    const [ean13, setEan13] = useState('');
    const [unidade, setUnidade] = useState('');
    const [descricaoUnidade, setDescricaoUnidade] = useState('');
    const [tipo, setTipo] = useState('');

    // Aba Fiscal Entrada
    const [situacaoTributariaEnt, setSituacaoTributariaEnt] = useState(""); // 'F' a 'T'
    const [origemEnt, setOrigemEnt] = useState(0); // '0', '1', '2'
    const [cfopCompra, setCfopCompra] = useState("");
    const [ncmEnt, setNcmEnt] = useState("");
    const [cestEnt, setCestEnt] = useState("");
    const [icmsEnt, setIcmsEnt] = useState(0); // índice do select (0 a 9)
    const [cstEnt, setCstEnt] = useState(0); // índice (0 a 10)
    const [ipiEnt, setIpiEnt] = useState(0); // índice (0 a 13)
    const [cofinsEnt, setCofinsEnt] = useState(0); // índice (0 a 9)
    const [pisEnt, setPisEnt] = useState(0); // índice (0 a 9)
    const [aliqIcmsEnt, setAliqIcmsEnt] = useState(0);

    // Aba Fiscal Saída
    const [situacaoTributariaSai, setSituacaoTributariaSai] = useState(""); // 'F' a 'T'
    const [origemSai, setOrigemSai] = useState(0); // '0', '1', '2'
    const [cfopVenda, setCfopVenda] = useState("");
    const [ncmSai, setNcmSai] = useState("");
    const [cestSai, setCestSai] = useState("");
    const [icmsSai, setIcmsSai] = useState(0); // índice do select (0 a 9)
    const [cstSai, setCstSai] = useState(0); // índice (0 a 10)
    const [ipiSai, setIpiSai] = useState(0); // índice (0 a 13)
    const [cofinsSai, setCofinsSai] = useState(0); // índice (0 a 9)
    const [pisSai, setPisSai] = useState(0); // índice (0 a 9)
    const [aliqIcmsSai, setAliqIcmsSai] = useState(0);

    //Campos Tamanho
    const [codtamanho, setCodTamanho] = useState(0);
    const [tamanho, setTamanho] = useState("");
    const [valoradicionaltamanho, setValorAdicionalTamanho] = useState(0);

    //Campos Preco por Tamanho
    const [codpreco, setCodPreco] = useState(0);
    const [serraria, setSerraria] = useState(0);
    const [montagemgrade, setMontagemGrade] = useState(0);
    const [marcenaria, setMarcenaria] = useState(0);
    const [colagemespuma, setColagemEspuma] = useState(0);
    const [cortetecido, setCorteTecido] = useState(0);
    const [costura, setCostura] = useState(0);
    const [enchimentoalmofada, setEnchimentoAlmofada] = useState(0);
    const [colagemtecido, setColagemTecido] = useState(0);
    const [coberta, setCoberta] = useState(0);
    const [entrega, setEntrega] = useState(0);

    //Campos Tecido
    const [codtecido, setCodTecido] = useState(0);
    const [tecido, setTecido] = useState("");
    const [valoradicionaltecido, setValorAdicionalTecido] = useState(0);

    //Campos Cor
    const [codcor, setCodCor] = useState(0);
    const [cor, setCor] = useState("");

    const [produtos, setProdutos] = useState([]);
    const [selecionados, setSelecionados] = useState([]);

    const handleOpen = (cad) => {
        setCodProduto(cad.codproduto);
        setIsOpen(true);
    };

    const handleConfirma = () => {
        setIsOpen(false);
        handleDelete();
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleTamanhoOpen = (cad) => {
        setCodTamanho(cad.codtamanho);
        setIsOpenTamanho(true);
    };

    const handleTamanhoConfirma = () => {
        setIsOpenTamanho(false);
        handleTamanhoDelete();
    };

    const handleTamanhoClose = () => {
        setIsOpenTamanho(false);
    };

    const handleTecidoOpen = (cad) => {
        setCodTecido(cad.codtecido);
        setIsOpenTecido(true);
    };

    const handleTecidoConfirma = () => {
        setIsOpenTecido(false);
        handleTecidoDelete();
    };

    const handleTecidoClose = () => {
        setIsOpenTecido(false);
    };

    const handleCorOpen = (cad) => {
        setCodCor(cad.codcor);
        setIsOpenCor(true);
    };

    const handleCorConfirma = () => {
        setIsOpenCor(false);
        handleCorDelete();
    };

    const handleCorClose = () => {
        setIsOpenCor(false);
    };

    const fetchData = async (searchTerm, page, limit) => {
        try {
            setLoading(true);
            setError(null);
            const response = await api.get("v1/cad/produto", {
                params: {
                    busca: searchTerm,
                    page,
                    per_page: limit,
                    codassinante,
                    tipo: filtroTipo
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setData(response.data.data);
            setPagination({
                total: response.data.pagination.Total,
                totalPages: response.data.pagination.TotalPages
            });
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            fetchData(search, currentPage, perPage);
        }, 1000); // Aguarda 1 segundo após o usuário parar de digitar

        // Cleanup function para limpar o timeout anterior
        return () => clearTimeout(timeoutId);
    }, [search, filtroTipo, currentPage, perPage]);

    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
        setCurrentPage(1); // Volta para primeira página ao mudar quantidade
    };

    const fetchDataTamanho = async (codigo) => {
        try {
            setLoading2(true);
            setError(null);
            const response = await api.get("v1/cad/produto/tamanho", {
                params: {
                    codproduto: codigo // Usa o código recebido por parâmetro
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setDataTamanho(response.data);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    };

    const fetchDataTecido = async (codigo) => {
        try {
            setLoading2(true);
            setError(null);
            const response = await api.get("v1/cad/produto/tecido", {
                params: {
                    codproduto: codigo // Usa o código recebido por parâmetro
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setDataTecido(response.data);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    };

    const fetchDataCor = async (codigo) => {
        try {
            setLoading2(true);
            setError(null);
            const response = await api.get("v1/cad/produto/cor", {
                params: {
                    codtecido: codigo // Usa o código recebido por parâmetro
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setDataCor(response.data);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    };

    const handleEdit = async (user) => {
        try {
            setLoading2(true);
            setError(null);

            // Primeira requisição
            const response = await api.get("v1/cad/produtoum", {
                params: {
                    codproduto: user.codproduto
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            setAbaAtiva("dados");
            setnovo(false);
            setCodProduto(user.codproduto);
            setDescricao(response.data.descricao);
            setValorBase(response.data.valorbase);
            setEan13(response.data.ean13);
            setUnidade(response.data.unidade);
            setDescricaoUnidade(response.data.descricaounidade);
            setTipo(response.data.tipo);

            setSituacaoTributariaEnt(response.data.situacaotributariaent);
            setOrigemEnt(response.data.origement);
            setCstEnt(response.data.cstent);
            setIcmsEnt(response.data.icmsent);
            setPisEnt(response.data.pisent);
            setCofinsEnt(response.data.cofinsent);
            setIpiEnt(response.data.ipient);
            setCfopCompra(response.data.cfopcompra);
            setNcmEnt(response.data.ncment);
            setCestEnt(response.data.cestent);
            setAliqIcmsEnt(response.data.aliqicmsent);

            setSituacaoTributariaSai(response.data.situacaotributariasai);
            setOrigemSai(response.data.origemsai);
            setCstSai(response.data.cstsai);
            setIcmsSai(response.data.icmssai);
            setPisSai(response.data.pissai);
            setCofinsSai(response.data.cofinssai);
            setIpiSai(response.data.ipisai);
            setCfopVenda(response.data.cfopvenda);
            setNcmSai(response.data.ncmsai);
            setCestSai(response.data.cestsai);
            setAliqIcmsSai(response.data.aliqicmssai);

            // Chama as funções passando o código do produto
            await Promise.all([
                fetchDataTamanho(user.codproduto),
                fetchDataTecido(user.codproduto),
            ]);

            setshowform(true);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            console.log('erro: ' + error)
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    };

    const handleDelete = async () => {
        try {
            setLoading(true);
            setError(null);
            await api.delete("v1/cad/produto", {
                params: {
                    codproduto,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            fetchData(search, currentPage, perPage);
            toast.success('Excluído com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    const handleTamanhoEdit = async (user) => {
        try {
            setLoading2(true);
            setError(null);
            const response = await api.get("v1/cad/produto/tamanhoum", {
                params: {
                    codtamanho: user.codtamanho
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setshowformtamanho(true);
            setnovotamanho(false);

            setCodTamanho(user.codtamanho);
            setTamanho(response.data.tamanho);
            setValorAdicionalTamanho(response.data.valoradicional);

            setCodPreco(response.data.codpreco);
            setSerraria(response.data.serraria);
            setMontagemGrade(response.data.montagemgrade);
            setMarcenaria(response.data.marcenaria);
            setColagemEspuma(response.data.colagemespuma);
            setCorteTecido(response.data.cortetecido);
            setCostura(response.data.costura);
            setEnchimentoAlmofada(response.data.enchimentoalmofada);
            setColagemTecido(response.data.colagemtecido);
            setCoberta(response.data.coberta);
            setEntrega(response.data.entrega);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    };

    const handleTamanhoDelete = async () => {
        try {
            setLoading2(true);
            setError(null);
            await api.delete("v1/cad/produto/tamanho", {
                params: {
                    codtamanho,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            fetchDataTamanho(codproduto);
            toast.success('Excluído com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    };

    const handleTecidoEdit = async (user) => {
        try {
            setLoading2(true);
            setError(null);
            const response = await api.get("v1/cad/produto/tecidoum", {
                params: {
                    codtecido: user.codtecido
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setshowformtecido(true);
            setnovotecido(false);

            setCodTecido(user.codtecido);
            setTecido(response.data.tecido);
            setValorAdicionalTecido(response.data.valoradicional);

            fetchDataCor(user.codtecido);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    };

    const handleTecidoDelete = async () => {
        try {
            setLoading2(true);
            setError(null);
            await api.delete("v1/cad/produto/tecido", {
                params: {
                    codtecido,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            fetchDataTecido(codproduto);
            toast.success('Excluído com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    };

    const handleCorDelete = async () => {
        try {
            setLoading2(true);
            setError(null);
            await api.delete("v1/cad/produto/cor", {
                params: {
                    codcor,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            fetchDataCor(codtecido);

            toast.success('Excluído com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    };

    const handleAdd = () => {
        setAbaAtiva("dados");
        setshowform(true);
        setnovo(true);

        setDataTamanho([]);
        setDataTecido([]);

        setCodProduto(0);
        setDescricao('');
        setValorBase(0);
        setEan13('');
        setUnidade('UN');
        setDescricaoUnidade('UNIDADE');
        setTipo('P');

        setSituacaoTributariaEnt('N');
        setOrigemEnt(0);
        setCstEnt(5);
        setIcmsEnt(2);
        setPisEnt(10);
        setCofinsEnt(10);
        setIpiEnt(5);
        setCfopCompra('1102');
        setNcmEnt('94016100');
        setCestEnt('');
        setAliqIcmsEnt(0);

        setSituacaoTributariaSai('N');
        setOrigemSai(0);
        setCstSai(5);
        setIcmsSai(2);
        setPisSai(10);
        setCofinsSai(10);
        setIpiSai(13);
        setCfopVenda('5102');
        setNcmSai('94016100');
        setCestSai('');
        setAliqIcmsSai(0);
    };

    const handleAddTamanho = () => {
        setshowformtamanho(true);
        setnovotamanho(true);

        setCodTamanho(0);
        setTamanho('');
        setSerraria(0);
        setMontagemGrade(0);
        setMarcenaria(0);
        setColagemEspuma(0);
        setCorteTecido(0);
        setCostura(0);
        setEnchimentoAlmofada(0);
        setColagemTecido(0);
        setCoberta(0);
        setEntrega(0);
    };

    const handleAddTecido = () => {
        setshowformtecido(true);
        setnovotecido(true);

        setCodTecido(0);
        setTecido('');
    };

    function Salvar() {
        novo ? Cadastrar() : Editar();
        setshowform(false);
    }

    function SalvarTamanho() {
        novotamanho ? CadastrarTamanho() : EditarTamanho();
        setshowformtamanho(false);
    }

    function SalvarTecido() {
        novotecido ? CadastrarTecido() : EditarTecido();
        setshowformtecido(false);
    }

    async function Editar() {
        try {
            setLoading2(true);
            setError(null);
            await api.put("v1/cad/produto", {
                descricao,
                valorbase,
                ean13,
                unidade,
                descricaoUnidade,
                situacaoTributariaEnt,
                origemEnt,
                cfopCompra,
                ncmEnt,
                cestEnt,
                icmsEnt,
                cstEnt,
                ipiEnt,
                cofinsEnt,
                pisEnt,
                aliqIcmsEnt,
                situacaoTributariaSai,
                origemSai,
                cfopVenda,
                ncmSai,
                cestSai,
                icmsSai,
                cstSai,
                ipiSai,
                cofinsSai,
                pisSai,
                aliqIcmsSai,
                tipo,
                codproduto
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });
            fetchData(search, currentPage, perPage);
            toast.success('Edição feita com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    }

    async function Cadastrar() {
        try {
            setLoading2(true);
            setError(null);
            const response = await api.post("v1/cad/produto", {
                descricao,
                valorbase,
                ean13,
                unidade,
                descricaoUnidade,
                situacaoTributariaEnt,
                origemEnt,
                cfopCompra,
                ncmEnt,
                cestEnt,
                icmsEnt,
                cstEnt,
                ipiEnt,
                cofinsEnt,
                pisEnt,
                aliqIcmsEnt,
                situacaoTributariaSai,
                origemSai,
                cfopVenda,
                ncmSai,
                cestSai,
                icmsSai,
                cstSai,
                ipiSai,
                cofinsSai,
                pisSai,
                aliqIcmsSai,
                excluido: "N",
                codassinante,
                codusuario,
                tipo,
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });

            setCodProduto(response.data.codproduto);
            fetchData(search, currentPage, perPage);
            toast.success('Registro Salvo com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    }

    async function EditarTamanho() {
        try {
            setLoading2(true);
            setError(null);
            await api.put("v1/cad/produto/tamanho", {
                tamanho,
                valoradicional: valoradicionaltamanho,
                codtamanho,
                codpreco,
                serraria,
                montagemgrade,
                marcenaria,
                colagemespuma,
                cortetecido,
                costura,
                enchimentoalmofada,
                colagemtecido,
                coberta,
                entrega
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });
            fetchDataTamanho(codproduto);
            toast.success('Edição feita com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    }

    async function CadastrarTamanho() {
        if (novo) {
            try {
                setLoading2(true);
                setError(null);
                const response = await api.post("v1/cad/produto", {
                    descricao,
                    valorbase,
                    ean13,
                    unidade,
                    descricaoUnidade,
                    situacaoTributariaEnt,
                    origemEnt,
                    cfopCompra,
                    ncmEnt,
                    cestEnt,
                    icmsEnt,
                    cstEnt,
                    ipiEnt,
                    cofinsEnt,
                    pisEnt,
                    aliqIcmsEnt,
                    situacaoTributariaSai,
                    origemSai,
                    cfopVenda,
                    ncmSai,
                    cestSai,
                    icmsSai,
                    cstSai,
                    ipiSai,
                    cofinsSai,
                    pisSai,
                    aliqIcmsSai,
                    excluido: "N",
                    codassinante,
                    codusuario,
                },
                    {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },

                    });

                setCodProduto(response.data.codproduto);
                setnovo(false);

                toast.success('Registro Salvo com Sucesso!');
            } catch (error) {
                console.error('Erro ao excluir dados:', error);
                setError('Erro ao tentar excluir os dados. Tente novamente.');
                toast.error('Ocorreu algum erro! ❌');
            } finally {
                setLoading2(false);
            }
        }

        try {
            setLoading2(true);
            setError(null);
            await api.post("v1/cad/produto/tamanho", {
                tamanho,
                excluido: "N",
                codproduto,

                serraria,
                montagemgrade,
                marcenaria,
                colagemespuma,
                cortetecido,
                costura,
                enchimentoalmofada,
                colagemtecido,
                coberta,
                entrega
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });

            fetchDataTamanho(codproduto);
            toast.success('Registro Salvo com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    }

    async function EditarTecido() {
        try {
            setLoading2(true);
            setError(null);
            await api.put("v1/cad/produto/tecido", {
                tecido,
                valoradicional: valoradicionaltecido,
                codtecido
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });
            fetchDataTecido(codproduto);
            toast.success('Edição feita com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    }

    async function CadastrarTecido() {
        if (novo) {
            try {
                setLoading2(true);
                setError(null);
                const response = await api.post("v1/cad/produto", {
                    descricao,
                    valorbase,
                    ean13,
                    unidade,
                    descricaoUnidade,
                    situacaoTributariaEnt,
                    origemEnt,
                    cfopCompra,
                    ncmEnt,
                    cestEnt,
                    icmsEnt,
                    cstEnt,
                    ipiEnt,
                    cofinsEnt,
                    pisEnt,
                    aliqIcmsEnt,
                    situacaoTributariaSai,
                    origemSai,
                    cfopVenda,
                    ncmSai,
                    cestSai,
                    icmsSai,
                    cstSai,
                    ipiSai,
                    cofinsSai,
                    pisSai,
                    aliqIcmsSai,
                    excluido: "N",
                    codassinante,
                    codusuario,
                },
                    {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },

                    });

                setCodProduto(response.data.codproduto);
                setnovo(false);

                toast.success('Registro Salvo com Sucesso!');
            } catch (error) {
                console.error('Erro ao excluir dados:', error);
                setError('Erro ao tentar excluir os dados. Tente novamente.');
                toast.error('Ocorreu algum erro! ❌');
            } finally {
                setLoading2(false);
            }
        }

        try {
            setLoading2(true);
            setError(null);
            const response = await api.post("v1/cad/produto/tecido", {
                tecido,
                excluido: "N",
                codproduto,
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });

            setCodTecido(response.data.codtecido);
            fetchDataTecido(codproduto);
            toast.success('Registro Salvo com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    }

    async function CadastrarCor() {
        if (novo) {
            try {
                setLoading2(true);
                setError(null);
                const response = await api.post("v1/cad/produto", {
                    descricao,
                    valorbase,
                    ean13,
                    unidade,
                    descricaoUnidade,
                    situacaoTributariaEnt,
                    origemEnt,
                    cfopCompra,
                    ncmEnt,
                    cestEnt,
                    icmsEnt,
                    cstEnt,
                    ipiEnt,
                    cofinsEnt,
                    pisEnt,
                    aliqIcmsEnt,
                    situacaoTributariaSai,
                    origemSai,
                    cfopVenda,
                    ncmSai,
                    cestSai,
                    icmsSai,
                    cstSai,
                    ipiSai,
                    cofinsSai,
                    pisSai,
                    aliqIcmsSai,
                    excluido: "N",
                    codassinante,
                    codusuario,
                },
                    {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },

                    });

                setCodProduto(response.data.codproduto);
                setnovo(false);

                toast.success('Produto Salvo com Sucesso!');

                try {
                    setLoading2(true);
                    setError(null);
                    const response1 = await api.post("v1/cad/produto/tecido", {
                        tecido,
                        excluido: "N",
                        codproduto: response.data.codproduto,
                    },
                        {
                            headers: {
                                Authorization: `Bearer ${accessKey}`,
                            },

                        });

                    setnovotecido(false);
                    setCodTecido(response1.data.codtecido);
                    fetchDataTecido(codproduto);
                    toast.success('Tecido Salvo com Sucesso!');

                    try {
                        setLoading2(true);
                        setError(null);
                        await api.post("v1/cad/produto/cor", {
                            cor,
                            excluido: "N",
                            codtecido: response1.data.codtecido,
                        },
                            {
                                headers: {
                                    Authorization: `Bearer ${accessKey}`,
                                },

                            });
                        fetchDataCor(response1.data.codtecido);
                        toast.success('Cor Salvo com Sucesso!');
                    } catch (error) {
                        console.error('Erro ao excluir dados:', error);
                        setError('Erro ao tentar excluir os dados. Tente novamente.');
                        toast.error('Ocorreu algum erro! ❌');
                    } finally {
                        setLoading2(false);
                    }
                } catch (error) {
                    console.error('Erro ao excluir dados:', error);
                    setError('Erro ao tentar excluir os dados. Tente novamente.');
                    toast.error('Ocorreu algum erro! ❌');
                } finally {
                    setLoading2(false);
                }
            } catch (error) {
                console.error('Erro ao excluir dados:', error);
                setError('Erro ao tentar excluir os dados. Tente novamente.');
                toast.error('Ocorreu algum erro! ❌');
            } finally {
                setLoading2(false);
            }
        } else {
            if (novotecido) {
                try {
                    setLoading2(true);
                    setError(null);
                    const response1 = await api.post("v1/cad/produto/tecido", {
                        tecido,
                        excluido: "N",
                        codproduto,
                    },
                        {
                            headers: {
                                Authorization: `Bearer ${accessKey}`,
                            },

                        });

                    setnovotecido(false);
                    setCodTecido(response1.data.codtecido);
                    fetchDataTecido(codproduto);
                    toast.success('Tecido Salvo com Sucesso!');

                    try {
                        setLoading2(true);
                        setError(null);
                        await api.post("v1/cad/produto/cor", {
                            cor,
                            excluido: "N",
                            codtecido: response1.data.codtecido,
                        },
                            {
                                headers: {
                                    Authorization: `Bearer ${accessKey}`,
                                },

                            });
                        fetchDataCor(response1.data.codtecido);
                        toast.success('Cor Salvo com Sucesso!');
                    } catch (error) {
                        console.error('Erro ao excluir dados:', error);
                        setError('Erro ao tentar excluir os dados. Tente novamente.');
                        toast.error('Ocorreu algum erro! ❌');
                    } finally {
                        setLoading2(false);
                    }
                } catch (error) {
                    console.error('Erro ao excluir dados:', error);
                    setError('Erro ao tentar excluir os dados. Tente novamente.');
                    toast.error('Ocorreu algum erro! ❌');
                } finally {
                    setLoading2(false);
                }
            } else {
                try {
                    setLoading2(true);
                    setError(null);
                    await api.post("v1/cad/produto/cor", {
                        cor,
                        excluido: "N",
                        codtecido,
                    },
                        {
                            headers: {
                                Authorization: `Bearer ${accessKey}`,
                            },

                        });
                    fetchDataCor(codtecido);
                    toast.success('Cor Salvo com Sucesso!');
                } catch (error) {
                    console.error('Erro ao excluir dados:', error);
                    setError('Erro ao tentar excluir os dados. Tente novamente.');
                    toast.error('Ocorreu algum erro! ❌');
                } finally {
                    setLoading2(false);
                }
            }
        }
    }

    const handleUnidadeChange = (value) => {
        setUnidade(value);

        const descricoes = {
            'ARR': 'ARROBA',
            'BAR': 'BARRIL',
            'BD': 'BALDE',
            'CE': 'BALDE',
            'CTL': 'CARTELA',
            'CX': 'CAIXA',
            'CTX': 'CAIXOTE',
            'DZ': 'DUZIA',
            'EMB': 'EMBALAGEM',
            'ENV': 'ENVELOPE',
            'FD': 'FARDO',
            'GF': 'GARRAFA',
            'GL': 'GALÃO',
            'KG': 'QUILOGRAMA',
            'KL': 'QUILOLITRO',
            'W': 'QUILOWATT HORA',
            'L': 'LITRO',
            'M2': 'METRO QUADRADO',
            'M3': 'METRO CÚBICO',
            'MI': 'MILHEIRO',
            'MT': 'METRO',
            'OUT': 'OUTRAS',
            'PCT': 'PACOTE',
            'PR': 'PAR',
            'PC': 'PEÇA',
            'RS': 'RESMA',
            'SC': 'SACA',
            'T': 'TONELADA',
            'UN': 'UNIDADE',
            'VD': 'VIDRO',
            'VR': 'VARA'
        };

        setDescricaoUnidade(descricoes[value] || '');
    };

    const origens = [
        { valor: 0, descricao: '0 - NACIONAL' },
        { valor: 1, descricao: '1 - IMPORTAÇÃO DIRETA' },
        { valor: 2, descricao: '2 - ESTRANGEIRA ADQUIRIDA NO MERCADO INTERNO' },
    ];

    const csts = [
        { valor: 0, descricao: '00 - TRIBUTADA INTEGRALMENTE' },
        { valor: 1, descricao: '10 - TRIBUTADA E COM COBRANÇA DO ICMS POR SUBSTITUIÇÃO TRIBUTÁRIA' },
        { valor: 2, descricao: '20 - COM REDUÇÃO DE BASE DE CÁLCULO' },
        { valor: 3, descricao: '30 - ISENTA OU NÃO TRIBUTADA E COM COBRANÇA DO ICMS POR ST' },
        { valor: 4, descricao: '40 - ISENTA' },
        { valor: 5, descricao: '41 - NÃO TRIBUTADA' },
        { valor: 6, descricao: '50 - SUSPENSÃO' },
        { valor: 7, descricao: '51 - DIFERIMENTO' },
        { valor: 8, descricao: '60 - ICMS COBRADO ANTERIORMENTE POR ST' },
        { valor: 9, descricao: '70 - REDUÇÃO DE BASE + COBRANÇA ICMS ST' },
        { valor: 10, descricao: '90 - OUTRAS' },
    ];

    const icmsOptions = [
        { valor: 0, descricao: '000 - VAZIO' },
        { valor: 1, descricao: '101 - TRIBUTADA COM PERMISSÃO DE CRÉDITO' },
        { valor: 2, descricao: '102 - TRIBUTADA SEM PERMISSÃO DE CRÉDITO' },
        { valor: 3, descricao: '103 - ISENÇÃO ICMS FAIXA DE RECEITA' },
        { valor: 4, descricao: '201 - CREDITO + ICMS ST' },
        { valor: 5, descricao: '202 - SEM CREDITO + ICMS ST' },
        { valor: 6, descricao: '203 - ISENTO + ICMS ST' },
        { valor: 7, descricao: '300 - IMUNE' },
        { valor: 8, descricao: '400 - NÃO TRIBUTADA' },
        { valor: 9, descricao: '500 - ICMS JÁ COBRADO (ST/ANTECIPAÇÃO)' },
        { valor: 10, descricao: '900 - OUTROS' },
    ];

    const pisOptions = [
        { valor: 1, descricao: 'PIS 01 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA BÁSICA' },
        { valor: 2, descricao: 'PIS 02 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA POR UNIDADE' },
        { valor: 3, descricao: 'PIS 03 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA POR UNIDADE' },
        { valor: 4, descricao: 'PIS 04 - MONOFÁSICA – ALÍQUOTA ZERO' },
        { valor: 5, descricao: 'PIS 05 - POR SUBSTITUIÇÃO TRIBUTÁRIA' },
        { valor: 6, descricao: 'PIS 06 - TRIBUTÁVEL A ALÍQUOTA ZERO' },
        { valor: 7, descricao: 'PIS 07 - ISENTA DA CONTRIBUIÇÃO' },
        { valor: 8, descricao: 'PIS 08 - SEM INCIDÊNCIA' },
        { valor: 9, descricao: 'PIS 09 - SUSPENSÃO DA CONTRIBUIÇÃO' },
        { valor: 10, descricao: 'PIS 49 - OUTRAS OPERAÇÕES DE SAÍDA' },
    ];

    const ipiOptions = [
        { valor: 0, descricao: 'IPI 00 - ENTRADA COM RECUPERAÇÃO DE CRÉDITO' },
        { valor: 1, descricao: 'IPI 01 - ENTRADA TRIBUTADA COM ALÍQUOTA ZERO' },
        { valor: 2, descricao: 'IPI 02 - ENTRADAS ISENTAS' },
        { valor: 3, descricao: 'IPI 03 - ENTRADA NÃO-INCIDÊNCIA' },
        { valor: 4, descricao: 'IPI 04 - ENTRADA IMUNE' },
        { valor: 5, descricao: 'IPI 05 - ENTRADA COM SUSPENSÃO' },
        { valor: 6, descricao: 'IPI 49 - OUTRAS ENTRADAS' },
        { valor: 7, descricao: 'IPI 50 - SAÍDA TRIBUTADA' },
        { valor: 8, descricao: 'IPI 51 - SAÍDA TRIBUTADA COM ALÍQUOTA ZERO' },
        { valor: 9, descricao: 'IPI 52 - SAÍDA ZERO' },
        { valor: 10, descricao: 'IPI 53 - SAÍDA NÃO-TRIBUTADA' },
        { valor: 11, descricao: 'IPI 54 - SAÍDA IMUNE' },
        { valor: 12, descricao: 'IPI 55 - SAÍDA COM SUSPENSÃO' },
        { valor: 13, descricao: 'IPI 99 - OUTRAS SAÍDAS' },
    ];

    function handleOpenReplicar() {
        setSelecionados([]);
        ListaProdutos();
    }

    async function ListaProdutos() {
        try {
            setLoading(true);
            setError(null);
            const response = await api.get("/v1/cad/produto/tecido/listaproduto", {
                params: {
                    codproduto,
                    codassinante,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setProdutos(response.data);
            setIsOpenTecidoReplicar(true);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    }

    // 🔹 Marcar / desmarcar produto
    const toggleSelecionado = (codProduto) => {
        setSelecionados((prev) =>
            prev.includes(codProduto)
                ? prev.filter((id) => id !== codProduto)
                : [...prev, codProduto]
        );
    };

    // 🔹 Enviar replicação para API
    const handleReplicar = async () => {
        if (selecionados.length === 0) {
            alert("Selecione ao menos um produto para replicar.");
            return;
        }

        setLoading(true);
        try {
            await api.post("/v1/cad/produto/tecido/replicartecido", {
                codtecidoorigem: codtecido,
                codprodutoorigem: codproduto,
                codprodutosdestino: selecionados,
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });

            alert("✅ Tecidos replicados com sucesso!");
        } catch (error) {
            console.error(error);
            alert("❌ Erro ao replicar tecidos.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="app-container">
                <Sidebar />
                <main className="content-container">
                    <PopUp isOpen={isOpen} onClose={handleClose}>
                        <h2>Verificação</h2>
                        <p>Tem certeza que deseja excluir esse registro?</p>

                        <div className="row">
                            <div className="col-12 mt-3 d-flex justify-content-end">
                                <button
                                    className="btn btn-primary me-2"
                                    onClick={handleConfirma}
                                >
                                    Sim
                                </button>
                                <button className="btn btn-danger" onClick={handleClose}>
                                    Não
                                </button>
                            </div>
                        </div>
                    </PopUp>

                    <PopUpTamanho isOpen={isOpenTamanho} onClose={handleTamanhoClose}>
                        <h2>Verificação</h2>
                        <p>Tem certeza que deseja excluir esse tamanho?</p>

                        <div className="row">
                            <div className="col-12 mt-3 d-flex justify-content-end">
                                <button
                                    className="btn btn-primary me-2"
                                    onClick={handleTamanhoConfirma}
                                >
                                    Sim
                                </button>
                                <button className="btn btn-danger" onClick={handleTamanhoClose}>
                                    Não
                                </button>
                            </div>
                        </div>
                    </PopUpTamanho>

                    <PopUpTecido isOpen={isOpenTecido} onClose={handleTecidoClose}>
                        <h2>Verificação</h2>
                        <p>Tem certeza que deseja excluir esse tecido?</p>

                        <div className="row">
                            <div className="col-12 mt-3 d-flex justify-content-end">
                                <button
                                    className="btn btn-primary me-2"
                                    onClick={handleTecidoConfirma}
                                >
                                    Sim
                                </button>
                                <button className="btn btn-danger" onClick={handleTecidoClose}>
                                    Não
                                </button>
                            </div>
                        </div>
                    </PopUpTecido>

                    <PopUpCor isOpen={isOpenCor} onClose={handleCorClose}>
                        <h2>Verificação</h2>
                        <p>Tem certeza que deseja excluir esse cor?</p>

                        <div className="row">
                            <div className="col-12 mt-3 d-flex justify-content-end">
                                <button
                                    className="btn btn-primary me-2"
                                    onClick={handleCorConfirma}
                                >
                                    Sim
                                </button>
                                <button className="btn btn-danger" onClick={handleCorClose}>
                                    Não
                                </button>
                            </div>
                        </div>
                    </PopUpCor>

                    <Modal
                        isOpen={showform}
                        onRequestClose={() => setshowform(false)}
                        overlayClassName="modal-overlay"
                        className="modal-content modal-xl"
                    >
                        <div className="container-fluid h-100">
                            <div className="modal-header">
                                {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
                                <button type="button" className="btn-close" onClick={() => setshowform(false)}></button>
                            </div>

                            <div className="modal-body">
                                <form>
                                    {/* CAMPOS GERAIS */}
                                    <div className='row'>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="descricao"
                                                    value={descricao}
                                                    onChange={(e) => setDescricao(e.target.value)}
                                                />
                                                <label htmlFor="descricao">Modelo</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="valorbase"
                                                    value={valorbase}
                                                    onChange={(e) => setValorBase(e.target.valueAsNumber)}
                                                />
                                                <label htmlFor="valorbase">Valor Base</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="ean13"
                                                    value={ean13}
                                                    onChange={(e) => setEan13(e.target.value)}
                                                />
                                                <label htmlFor="ean13">Código de Barra</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <select
                                                    className="form-select"
                                                    id="unidade"
                                                    value={unidade}
                                                    onChange={(e) => handleUnidadeChange(e.target.value)}
                                                >
                                                    <option value="">Selecione</option>
                                                    <option value="ARR">ARR</option>
                                                    <option value="BAR">BAR</option>
                                                    <option value="BD">BD</option>
                                                    <option value="CE">CE</option>
                                                    <option value="CTL">CTL</option>
                                                    <option value="CX">CX</option>
                                                    <option value="CTX">CTX</option>
                                                    <option value="DZ">DZ</option>
                                                    <option value="EMB">EMB</option>
                                                    <option value="ENV">ENV</option>
                                                    <option value="FD">FD</option>
                                                    <option value="GF">GF</option>
                                                    <option value="GL">GL</option>
                                                    <option value="KG">KG</option>
                                                    <option value="KL">KL</option>
                                                    <option value="W">W</option>
                                                    <option value="L">L</option>
                                                    <option value="M2">M2</option>
                                                    <option value="M3">M3</option>
                                                    <option value="MI">MI</option>
                                                    <option value="MT">MT</option>
                                                    <option value="OUT">OUT</option>
                                                    <option value="PCT">PCT</option>
                                                    <option value="PR">PR</option>
                                                    <option value="PC">PC</option>
                                                    <option value="RS">RS</option>
                                                    <option value="SC">SC</option>
                                                    <option value="T">T</option>
                                                    <option value="UN">UN</option>
                                                    <option value="VD">VD</option>
                                                    <option value="VR">VR</option>
                                                </select>
                                                <label htmlFor="unidade">UND</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="descricaoUnidade"
                                                    value={descricaoUnidade}
                                                    onChange={(e) => setDescricaoUnidade(e.target.value)}
                                                    disabled
                                                />
                                                <label htmlFor="descricaoUnidade">UND Descrição</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-group">
                                                <label className="d-block">Tipo</label>
                                                <div className="row">
                                                    {[
                                                        { label: 'Produto', value: 'P' },
                                                        { label: 'Serviço', value: 'S' },
                                                        { label: 'Insumo', value: 'I' },
                                                    ].map((op, index) => (
                                                        <div className="col-md-4" key={index}>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="tipo"
                                                                    id={`tipo_${index}`}
                                                                    value={op.value}
                                                                    checked={tipo === op.value}
                                                                    onChange={(e) => setTipo(e.target.value)}
                                                                />
                                                                <label className="form-check-label" htmlFor={`tipo_${index}`}>
                                                                    {op.label}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* ABAS DE CONTROLE */}
                                    {tipo !== 'I' && (<ul className="nav nav-tabs mt-3">
                                        <li className="nav-item">
                                            <button type='button' className={`nav-link ${abaAtiva === "dados" ? "active" : ""}`} onClick={() => setAbaAtiva("dados")}>
                                                Tamanhos / Tecidos / Cores
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button type='button' className={`nav-link ${abaAtiva === "entrada" ? "active" : ""}`} onClick={() => setAbaAtiva("entrada")}>
                                                Fiscal Entrada
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button type='button' className={`nav-link ${abaAtiva === "saida" ? "active" : ""}`} onClick={() => setAbaAtiva("saida")}>
                                                Fiscal Saída
                                            </button>
                                        </li>
                                    </ul>)}


                                    {/* CONTEÚDO DAS ABAS */}
                                    {tipo !== 'I' && (<div className="tab-content mt-3">
                                        {abaAtiva === "dados" && (
                                            <div className="tab-pane active">
                                                <div className="row">
                                                    <div className='col-xl-6 mb-2'>
                                                        <button className='btn btn-outline-primary w-100' type='button' onClick={handleAddTamanho}>
                                                            Adicionar Tamanho
                                                        </button>
                                                        <TableTamanho
                                                            columns={columnsTamanho}
                                                            data={dataTamanho}
                                                            onEdit={handleTamanhoEdit}
                                                            onDelete={handleTamanhoOpen}
                                                        />
                                                    </div>

                                                    <div className='col-xl-6 mb-2'>
                                                        <button className='btn btn-outline-primary w-100' type='button' onClick={handleAddTecido}>
                                                            Adicionar Tecido
                                                        </button>
                                                        <TableTecido
                                                            columns={columnsTecido}
                                                            data={dataTecido}
                                                            onEdit={handleTecidoEdit}
                                                            onDelete={handleTecidoOpen}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {abaAtiva === "entrada" && (
                                            <div className="tab-pane active">
                                                <div className="row">
                                                    {/* Exemplo de campos fiscais de entrada */}
                                                    <div className="form-group">
                                                        <label className="d-block">Situação Tributária Entrada</label>
                                                        <div className="row">
                                                            {[
                                                                { label: 'Substituição Tributária 1', value: 'F' },
                                                                { label: 'Substituição Tributária 2', value: 'G' },
                                                                { label: 'Substituição Tributária 3', value: 'H' },
                                                                { label: 'Isento 1', value: 'I' },
                                                                { label: 'Isento 2', value: 'J' },
                                                                { label: 'Isento 3', value: 'K' },
                                                                { label: 'Não Tributado 1', value: 'N' },
                                                                { label: 'Não Tributado 2', value: 'O' },
                                                                { label: 'Não Tributado 3', value: 'P' },
                                                                { label: 'Isento ISSQN', value: 'Q' },
                                                                { label: 'Tributada pelo ISSQN', value: 'S' },
                                                                { label: 'Tributada pelo ICMS', value: 'T' },
                                                            ].map((op, index) => (
                                                                <div className="col-md-4" key={index}>
                                                                    <div className="form-check">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="situacaoTributariaEnt"
                                                                            id={`situacaoTributariaEnt_${index}`}
                                                                            value={op.value}
                                                                            checked={situacaoTributariaEnt === op.value}
                                                                            onChange={(e) => setSituacaoTributariaEnt(e.target.value)}
                                                                        />
                                                                        <label className="form-check-label" htmlFor={`situacaoTributariaEnt_${index}`}>
                                                                            {op.label}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>

                                                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                        <div className="form-floating">
                                                            <select className="form-select" value={origemEnt} onChange={(e) => setOrigemEnt(Number(e.target.value))}>
                                                                <option value="">Selecione</option>
                                                                {origens.map(o => (
                                                                    <option key={o.valor} value={o.valor}>{o.descricao}</option>
                                                                ))}
                                                            </select>
                                                            <label>Origem Entrada:</label>
                                                        </div>
                                                    </div>

                                                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                        <div className="form-floating">
                                                            <select className="form-select" value={cstEnt} onChange={(e) => setCstEnt(Number(e.target.value))}>
                                                                <option value="">Selecione</option>
                                                                {csts.map(c => (
                                                                    <option key={c.valor} value={c.valor}>{c.descricao}</option>
                                                                ))}
                                                            </select>
                                                            <label>CST Entrada:</label>
                                                        </div>
                                                    </div>

                                                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                        <div className="form-floating">
                                                            <select className="form-select" value={icmsEnt} onChange={(e) => setIcmsEnt(Number(e.target.value))}>
                                                                <option value="">Selecione</option>
                                                                {icmsOptions.map(i => (
                                                                    <option key={i.valor} value={i.valor}>{i.descricao}</option>
                                                                ))}
                                                            </select>
                                                            <label>ICMS Entrada:</label>
                                                        </div>
                                                    </div>

                                                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                        <div className="form-floating">
                                                            <select className="form-select" value={pisEnt} onChange={(e) => setPisEnt(Number(e.target.value))}>
                                                                <option value="">Selecione</option>
                                                                {pisOptions.map(p => (
                                                                    <option key={p.valor} value={p.valor}>{p.descricao}</option>
                                                                ))}
                                                            </select>
                                                            <label>PIS Entrada:</label>
                                                        </div>
                                                    </div>

                                                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                        <div className="form-floating">
                                                            <select className="form-select" value={cofinsEnt} onChange={(e) => setCofinsEnt(Number(e.target.value))}>
                                                                <option value="">Selecione</option>
                                                                {pisOptions.map(p => (
                                                                    <option key={p.valor} value={p.valor}>{p.descricao.replace('PIS', 'COFINS')}</option>
                                                                ))}
                                                            </select>
                                                            <label>COFINS Entrada:</label>
                                                        </div>
                                                    </div>

                                                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                        <div className="form-floating">
                                                            <select className="form-select" value={ipiEnt} onChange={(e) => setIpiEnt(Number(e.target.value))}>
                                                                <option value="">Selecione</option>
                                                                {ipiOptions.map(i => (
                                                                    <option key={i.valor} value={i.valor}>{i.descricao}</option>
                                                                ))}
                                                            </select>
                                                            <label>IPI Entrada:</label>
                                                        </div>
                                                    </div>

                                                    <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2'>
                                                        <div className="form-floating">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={cfopCompra}
                                                                onChange={(e) => setCfopCompra(e.target.value)}
                                                            />
                                                            <label>CFOP Compra</label>
                                                        </div>
                                                    </div>

                                                    <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2'>
                                                        <div className="form-floating">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={ncmEnt}
                                                                onChange={(e) => setNcmEnt(e.target.value)}
                                                            />
                                                            <label>NCM Entrada</label>
                                                        </div>
                                                    </div>

                                                    <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2'>
                                                        <div className="form-floating">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={cestEnt}
                                                                onChange={(e) => setCestEnt(e.target.value)}
                                                            />
                                                            <label>CEST Entrada</label>
                                                        </div>
                                                    </div>

                                                    <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2'>
                                                        <div className="form-floating">
                                                            <input
                                                                type="number"
                                                                step="0.01"
                                                                className="form-control"
                                                                value={aliqIcmsEnt}
                                                                onChange={(e) => setAliqIcmsEnt(e.target.value)}
                                                            />
                                                            <label>Alíquota ICMS Entrada</label>
                                                        </div>
                                                    </div>
                                                    {/* Continue os demais campos fiscais de entrada aqui */}
                                                </div>
                                            </div>
                                        )}

                                        {abaAtiva === "saida" && (
                                            <div className="tab-pane active">
                                                <div className="row">
                                                    {/* Exemplo de campos fiscais de saída */}
                                                    <div className="form-group">
                                                        <label className="d-block">Situação Tributária Saída</label>
                                                        <div className="row">
                                                            {[
                                                                { label: 'Substituição Tributária 1', value: 'F' },
                                                                { label: 'Substituição Tributária 2', value: 'G' },
                                                                { label: 'Substituição Tributária 3', value: 'H' },
                                                                { label: 'Isento 1', value: 'I' },
                                                                { label: 'Isento 2', value: 'J' },
                                                                { label: 'Isento 3', value: 'K' },
                                                                { label: 'Não Tributado 1', value: 'N' },
                                                                { label: 'Não Tributado 2', value: 'O' },
                                                                { label: 'Não Tributado 3', value: 'P' },
                                                                { label: 'Isento ISSQN', value: 'Q' },
                                                                { label: 'Tributada pelo ISSQN', value: 'S' },
                                                                { label: 'Tributada pelo ICMS', value: 'T' },
                                                            ].map((op, index) => (
                                                                <div className="col-md-4" key={index}>
                                                                    <div className="form-check">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="situacaoTributariaSai"
                                                                            id={`situacaoTributariaSai_${index}`}
                                                                            value={op.value}
                                                                            checked={situacaoTributariaSai === op.value}
                                                                            onChange={(e) => setSituacaoTributariaSai(e.target.value)}
                                                                        />
                                                                        <label className="form-check-label" htmlFor={`situacaoTributariaSai_${index}`}>
                                                                            {op.label}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>

                                                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                        <div className="form-floating">
                                                            <select className="form-select" value={origemSai} onChange={(e) => setOrigemSai(Number(e.target.value))}>
                                                                <option value="">Selecione</option>
                                                                {origens.map(o => (
                                                                    <option key={o.valor} value={o.valor}>{o.descricao}</option>
                                                                ))}
                                                            </select>
                                                            <label>Origem Saída:</label>
                                                        </div>
                                                    </div>

                                                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                        <div className="form-floating">
                                                            <select className="form-select" value={cstSai} onChange={(e) => setCstSai(Number(e.target.value))}>
                                                                <option value="">Selecione</option>
                                                                {csts.map(c => (
                                                                    <option key={c.valor} value={c.valor}>{c.descricao}</option>
                                                                ))}
                                                            </select>
                                                            <label>CST Saída:</label>
                                                        </div>
                                                    </div>

                                                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                        <div className="form-floating">
                                                            <select className="form-select" value={icmsSai} onChange={(e) => setIcmsSai(Number(e.target.value))}>
                                                                <option value="">Selecione</option>
                                                                {icmsOptions.map(i => (
                                                                    <option key={i.valor} value={i.valor}>{i.descricao}</option>
                                                                ))}
                                                            </select>
                                                            <label>ICMS Saída:</label>
                                                        </div>
                                                    </div>

                                                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                        <div className="form-floating">
                                                            <select className="form-select" value={pisSai} onChange={(e) => setPisSai(Number(e.target.value))}>
                                                                <option value="">Selecione</option>
                                                                {pisOptions.map(p => (
                                                                    <option key={p.valor} value={p.valor}>{p.descricao}</option>
                                                                ))}
                                                            </select>
                                                            <label>PIS Saída:</label>
                                                        </div>
                                                    </div>

                                                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                        <div className="form-floating">
                                                            <select className="form-select" value={cofinsSai} onChange={(e) => setCofinsSai(Number(e.target.value))}>
                                                                <option value="">Selecione</option>
                                                                {pisOptions.map(p => (
                                                                    <option key={p.valor} value={p.valor}>{p.descricao.replace('PIS', 'COFINS')}</option>
                                                                ))}
                                                            </select>
                                                            <label>COFINS Saída:</label>
                                                        </div>
                                                    </div>

                                                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                        <div className="form-floating">
                                                            <select className="form-select" value={ipiSai} onChange={(e) => setIpiSai(Number(e.target.value))}>
                                                                <option value="">Selecione</option>
                                                                {ipiOptions.map(i => (
                                                                    <option key={i.valor} value={i.valor}>{i.descricao}</option>
                                                                ))}
                                                            </select>
                                                            <label>IPI Saída:</label>
                                                        </div>
                                                    </div>

                                                    <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2'>
                                                        <div className="form-floating">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={cfopVenda}
                                                                onChange={(e) => setCfopVenda(e.target.value)}
                                                            />
                                                            <label>CFOP Venda</label>
                                                        </div>
                                                    </div>

                                                    <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2'>
                                                        <div className="form-floating">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={ncmSai}
                                                                onChange={(e) => setNcmSai(e.target.value)}
                                                            />
                                                            <label>NCM Saída</label>
                                                        </div>
                                                    </div>

                                                    <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2'>
                                                        <div className="form-floating">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={cestSai}
                                                                onChange={(e) => setCestSai(e.target.value)}
                                                            />
                                                            <label>CEST Saída</label>
                                                        </div>
                                                    </div>

                                                    <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2'>
                                                        <div className="form-floating">
                                                            <input
                                                                type="number"
                                                                step="0.01"
                                                                className="form-control"
                                                                value={aliqIcmsSai}
                                                                onChange={(e) => setAliqIcmsSai(e.target.value)}
                                                            />
                                                            <label>Alíquota ICMS Saída</label>
                                                        </div>
                                                    </div>
                                                    {/* Continue os demais campos fiscais de saída aqui */}
                                                </div>
                                            </div>
                                        )}
                                    </div>)}


                                </form>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={() => setshowform(false)}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-success" onClick={Salvar}>
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </Modal>

                    <ModalTamanho
                        isOpen={showformtamanho}
                        onRequestClose={() => setshowformtamanho(false)}
                        overlayClassName="modal-overlay"
                        className="modal-content modal-lg"
                    >
                        <div className="container-fluid h-100">
                            <div className="modal-header">
                                {novotamanho ? <h2>Novo Tamanho</h2> : <h2>Editando Tamanho</h2>}
                                <button type="button" className="btn-close" onClick={() => setshowformtamanho(false)}></button>
                            </div>

                            <div className="modal-body">
                                <form>
                                    <div className='row'>
                                        <div className='col-xl-8 col-lg-8 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="tamanho"
                                                    value={tamanho}
                                                    onChange={(e) => setTamanho(e.target.value)}
                                                />
                                                <label htmlFor="tamanho">Tamanho</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="valoradicionaltamanho"
                                                    value={valoradicionaltamanho}
                                                    onChange={(e) => setValorAdicionalTamanho(e.target.valueAsNumber)}
                                                />
                                                <label htmlFor="valoradicionaltamanho">Valor Adicional</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <hr />
                                        <h3 className='text-center'>Preço de produção</h3>
                                        <hr />
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="serraria"
                                                    value={serraria}
                                                    onChange={(e) => setSerraria(e.target.value)}
                                                />
                                                <label htmlFor="serraria">Serraria</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="montagemgrade"
                                                    value={montagemgrade}
                                                    onChange={(e) => setMontagemGrade(e.target.value)}
                                                />
                                                <label htmlFor="montagemgrade">Montagem Grade</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="marcenaria"
                                                    value={marcenaria}
                                                    onChange={(e) => setMarcenaria(e.target.value)}
                                                />
                                                <label htmlFor="marcenaria">Marcenaria</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="colagemespuma"
                                                    value={colagemespuma}
                                                    onChange={(e) => setColagemEspuma(e.target.value)}
                                                />
                                                <label htmlFor="colagemespuma">Colagem Espuma</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="cortetecido"
                                                    value={cortetecido}
                                                    onChange={(e) => setCorteTecido(e.target.value)}
                                                />
                                                <label htmlFor="cortetecido">Corte Tecido</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="costura"
                                                    value={costura}
                                                    onChange={(e) => setCostura(e.target.value)}
                                                />
                                                <label htmlFor="costura">Costura</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="enchimentoalmofada"
                                                    value={enchimentoalmofada}
                                                    onChange={(e) => setEnchimentoAlmofada(e.target.value)}
                                                />
                                                <label htmlFor="enchimentoalmofada">Enchimento Almofada</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="colagemtecido"
                                                    value={colagemtecido}
                                                    onChange={(e) => setColagemTecido(e.target.value)}
                                                />
                                                <label htmlFor="colagemtecido">Colagem Tecido</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="coberta"
                                                    value={coberta}
                                                    onChange={(e) => setCoberta(e.target.value)}
                                                />
                                                <label htmlFor="coberta">Coberta</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="entrega"
                                                    value={entrega}
                                                    onChange={(e) => setEntrega(e.target.value)}
                                                />
                                                <label htmlFor="entrega">Entrega</label>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={() => setshowformtamanho(false)}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-success" onClick={SalvarTamanho}>
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </ModalTamanho>

                    <ModalTecido
                        isOpen={showformtecido}
                        onRequestClose={() => setshowformtecido(false)}
                        overlayClassName="modal-overlay"
                        className="modal-content modal-lg"
                    >
                        <div className="container-fluid h-100">
                            <div className="modal-header">
                                {novotecido ? <h2>Novo Tecido</h2> : <h2>Editando Tecido</h2>}
                                <button type="button" className="btn-close" onClick={() => setshowformtecido(false)}></button>
                            </div>

                            <div className="modal-body">
                                <form>
                                    <div className='row'>
                                        <div className='col-xl-8 col-lg-8 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="tecido"
                                                    value={tecido}
                                                    onChange={(e) => setTecido(e.target.value)}
                                                />
                                                <label htmlFor="tecido">Tecido</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="valoradicionaltecido"
                                                    value={valoradicionaltecido}
                                                    onChange={(e) => setValorAdicionalTecido(e.target.valueAsNumber)}
                                                />
                                                <label htmlFor="valoradicionaltecido">Valor Adicional</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-8 col-lg-8 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="cor"
                                                    value={cor}
                                                    onChange={(e) => setCor(e.target.value)}
                                                />
                                                <label htmlFor="cor">Cor</label>
                                            </div>
                                        </div>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <button type="button" className="btn btn-success" onClick={CadastrarCor}>
                                                Adicionar
                                            </button>
                                        </div>
                                        <div>
                                            <TableCor
                                                columns={columnsCor}
                                                data={dataCor}
                                                onDelete={handleCorOpen}
                                            />
                                        </div>


                                    </div>
                                </form>
                            </div>

                            <div className="modal-footer">
                                {codtecido !== 0 && (<button type="button" className="btn btn-primary" onClick={handleOpenReplicar}>
                                    Replicar
                                </button>)}
                                <button type="button" className="btn btn-danger" onClick={() => setshowformtecido(false)}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-success" onClick={SalvarTecido}>
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </ModalTecido>

                    <ModalTecidoReplicar
                        isOpen={isOpenTecidoReplicar}
                        onRequestClose={() => setIsOpenTecidoReplicar(false)}
                        contentLabel="Selecionar Produtos"
                        className="modal-content"
                        overlayClassName="modal-overlay"
                    >
                        <h2>Selecionar Produtos para Replicar</h2>
                        <p>Selecione os produtos que receberão o tecido.</p>

                        <div className="product-list">
                            {produtos.map((p) => (
                                <label key={p.codproduto} className="product-item">
                                    <input
                                        type="checkbox"
                                        checked={selecionados.includes(p.codproduto)}
                                        onChange={() => toggleSelecionado(p.codproduto)}
                                    />
                                    {p.descricao} (#{p.codproduto})
                                </label>
                            ))}
                        </div>

                        <div className="modal-actions">
                            <button type='button' className='btn btn-danger' onClick={() => setIsOpenTecidoReplicar(false)}>Cancelar</button>
                            <button type='button' className='btn btn-success' onClick={handleReplicar} disabled={loading}>
                                {loading ? "Replicando..." : "Replicar Tecidos"}
                            </button>
                        </div>

                        <style jsx>{`
        .modal-content {
          background: #fff;
          padding: 20px;
          border-radius: 12px;
          width: 500px;
          margin: auto;
        }
        .product-list {
          max-height: 300px;
          overflow-y: auto;
          border: 1px solid #ddd;
          padding: 10px;
          margin: 10px 0;
        }
        .product-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 5px 0;
        }
        .modal-actions {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }
      `}</style>
                    </ModalTecidoReplicar>

                    <div className="container-fluid py-4 d-flex flex-column" style={{ minHeight: '100vh' }}>
                        <Title text="Cadastro de Produto" icon="user" />
                        <Description text="Cadastro dos produtos da empresa" />

                        <div className="row mb-3">
                            <div className="col-xl-7 col-lg-6 col-md-8 col-sm-12">
                                <SearchField
                                    value={search}
                                    onChange={setSearch}
                                    placeholder="Buscar produtos por: Código ou Modelo"
                                />
                            </div>

                            <div className="col-xl-3 col-lg-6 col-md-4 col-sm-12 mb-2">
                                <div className="d-flex flex-wrap gap-2" role="group" aria-label="Filtro de status">
                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="filtro"
                                        id="filtroTodos"
                                        value="T"
                                        checked={filtroTipo === "T"}
                                        onChange={(e) => setFiltroTipo(e.target.value)}
                                    />
                                    <label className="btn btn-outline-primary" htmlFor="filtroTodos">
                                        Todos
                                    </label>

                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="filtro"
                                        id="filtroProduto"
                                        value="P"
                                        checked={filtroTipo === "P"}
                                        onChange={(e) => setFiltroTipo(e.target.value)}
                                    />
                                    <label className="btn btn-outline-primary" htmlFor="filtroProduto">
                                        Produtos
                                    </label>

                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="filtro"
                                        id="filtroServico"
                                        value="S"
                                        checked={filtroTipo === "S"}
                                        onChange={(e) => setFiltroTipo(e.target.value)}
                                    />
                                    <label className="btn btn-outline-primary" htmlFor="filtroServico">
                                        Serviço
                                    </label>

                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="filtro"
                                        id="filtroInsumo"
                                        value="I"
                                        checked={filtroTipo === "I"}
                                        onChange={(e) => setFiltroTipo(e.target.value)}
                                    />
                                    <label className="btn btn-outline-primary" htmlFor="filtroInsumo">
                                        Insumo
                                    </label>
                                </div>
                            </div>

                            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12 text-center">
                                <AddButton onClick={handleAdd} text="Novo Produto" disabled={!podeInserir("/cad/produto")} />
                            </div>
                        </div>

                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error}
                            </div>
                        )}

                        {loading2 && <Aguarte />
                        }
                        <div className="flex-grow-1 d-flex flex-column">
                            {loading ? (
                                <div className="text-center py-4">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Carregando...</span>
                                    </div>
                                </div>
                            ) : (
                                <div className="table-wrapper flex-grow-1 d-flex flex-column">
                                    <Table
                                        columns={columns}
                                        data={data}
                                        onEdit={handleEdit}
                                        isEditDisabled={() => !podeEditar("/cad/produto")}
                                        onDelete={handleOpen}
                                        isDeleteDisabled={() => !podeExcluir("/cad/produto")}
                                    />
                                </div>
                            )}
                        </div>

                        <Pagination
                            currentPage={currentPage}
                            totalPages={pagination.totalPages}
                            onPageChange={setCurrentPage}
                            perPage={perPage}
                            onPerPageChange={handlePerPageChange}
                            total={pagination.total}
                        />
                    </div>
                </main>
            </div>
        </>
    );
};

export default CadProduto;